import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { Card } from "src/app/ui/models/domains/pbm/Beneficiary/card";
import { Dependent } from "src/app/ui/models/domains/pbm/Beneficiary/dependent";
import { OrderCardDTO } from "src/app/ui/models/domains/pbm/Beneficiary/dto/order-card-dto";
import { GenderType } from "src/app/ui/models/domains/pbm/Beneficiary/gender-type";
import { Gender, MaritalStatus } from "src/app/ui/models/domains/pbm/Beneficiary/person";
import { BeneficiaryKey } from "src/app/ui/models/domains/pbm/Benefit/beneficiary-key";
import { Address } from "src/app/ui/models/domains/pbm/companies/address";
import { StateAcronym } from "src/app/ui/models/domains/pbm/state/state-acronym";
import { City } from "src/app/ui/models/domains/pbm/state/city";
import { UserPermissions } from "src/app/ui/models/domains/pbm/user/user-permissions";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { FormDirty } from "src/app/ui/models/utils/form-dirty.utils";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { LoadingService } from "src/app/ui/services/loading.service";
import { BeneficiaryService } from "src/app/ui/services/pbm/beneficiary.service";
import { UserService } from "src/app/ui/services/user.service";
import { Toast } from "../../../toast/toast";
import { ConfirmDialog } from "../../shared/dialogs/confirm-dialog/confirm-dialog.component";
import { CardBlockDialogComponent } from "../dialogs/card-block-dialog/card-block-dialog.component";
import { CardOrderDialogComponent } from "../dialogs/card-order-dialog/card-order-dialog.component";
import { CardUnblockDialogComponent } from "../dialogs/card-unblock-dialog/card-unblock-dialog.component";
import { AddDependentBehaviorValidator, DependentValidator, EditDependentBehaviorValidator } from "../validators/dependent-validator";
import { StateService } from "src/app/ui/services/pbm/state.service";
import { VinculatedSocialnumberDialogComponent } from "../registration-beneficiary/vinculated-socialnumber/vinculated-socialnumber-dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";

@Component({
  selector: "edit-dependent",
  templateUrl: "./edit-dependent.component.html",
  styleUrls: ["./edit-dependent.component.scss"],
})
export class EditDependentComponent implements OnInit {
  private beneficiary: Beneficiary;
  private dependent: Dependent;
  private fiscalNumber: string;

  private cardBlockDialogRef: MatDialogRef<CardBlockDialogComponent>;
  private cardUnblockDialogRef: MatDialogRef<CardUnblockDialogComponent>;
  private confirmDialogRef: MatDialogRef<ConfirmDialog>;
  private cardOrderDialogRef: MatDialogRef<CardOrderDialogComponent>;

  private formDirty: FormDirty = new FormDirty();

  public fiscalNumberMask = MaskInput.getFicalNumberMask();
  public socialNumberMask = MaskInput.getSocialNumberMask();
  public dateMask = MaskInput.getDateMask();
  public zipCodeMask = MaskInput.getZipCodeMask();
  public telephoneMask = MaskInput.getTelephoneMask();
  public mobileMask = MaskInput.getMobileMask();
  public genderType = GenderType;


  private stateList: StateAcronym[] = [];
  private cityList: City[] = [];
  public alertLogin = false;
  public userErrorVisible = false;
  public beneficiaryInfo = null;
  public socialNumberFind = '';

  public dependentForm: UntypedFormGroup = this.formBuilder.group(
    {
      active: [true],
      beneficiaryKey: [""],
      beneficiarySocialNumber: [""],
      cardNumber: [""],
      name: ["", Validators.required],
      socialNumber: ["", Validators.required],
      birthDate: [""],
      gender: [0, Validators.required],
      maritalStatus: [0, Validators.required],
      isNewAddress: [false],
      street: [""],
      number: [""],
      complement: [""],
      district: ["", Validators.required],
      region: [0, Validators.required],
      city: [{ value: 0, disabled: true }, Validators.required],
      zipCode: [""],
      email: ["", Validators.required],
      telephone: [""],
      mobile: [""],
      needValidateEmail: [false],
      enableDelivery: [false],
      transactionPasswordRequired: [false, [Validators.required]]
    },
    { },
  );
  company: Company;
  constructor(
    private featureViewService: FeatureViewService,
    private beneficiaryService: BeneficiaryService,
    private formBuilder: UntypedFormBuilder,
    private loadingService: LoadingService,
    private stateService: StateService,
    private userService: UserService,
    private router: Router,
    private toast: Toast,
    private dialog: MatDialog,
  ) {
    this.featureViewService.activeFeatureView(FeatureViews.BeneficiaryEditDependentFeatureView, PageViews.BeneficiaryPageView);
    this.beneficiary = this.beneficiaryService.getBeneficiary();
    this.company = this.beneficiaryService.getBeneficiary()?.getCompany()[0];
    this.dependent = this.beneficiaryService.getDependent();
    this.fiscalNumber = this.userService.getUserProfile().getPreferences().getFilterText();
  }

  async ngOnInit() {
    this.stateList = await this.stateService.getStates();

    if (!this.beneficiary || !this.dependent) {
      this.router.navigate([RoutePath.SearchBeneficiary]);
    } else if (this.dependent.isNew()) {
      const beneficiaryKey = new BeneficiaryKey();
      beneficiaryKey.setValue("");
      this.dependentForm.patchValue({
        beneficiaryKey: beneficiaryKey,
        beneficiarySocialNumber: this.dependent.getBeneficiarySocialNumber(),
      });
    } else {
      this.patchRegistrationDependentForm();
    }
  }

  public getDependent(): Dependent {
    return this.dependent;
  }

  private async patchRegistrationDependentForm(): Promise<void> {
    const state = this.stateList.find((state) => state.getValue() === this.dependent.getAddress().getRegion());
    if (state) {
      this.cityList = await this.stateService.getCityByStateAcronym(state);
    }

    const city = this.cityList.find((city) => city.getName() === this.dependent.getAddress().getCity());

    this.dependentForm.patchValue({
      beneficiaryKey: this.dependent.getBeneficiaryKey(),
      beneficiarySocialNumber: this.dependent.getBeneficiarySocialNumber(),
      active: this.dependent.isActive(),
      cardNumber: this.dependent.getCard().getCardNumber(),
      name: this.dependent.getName(),
      socialNumber: this.dependent.getSocialNumber(),
      birthDate: this.dependent.getBirthDate(),
      gender: this.dependent.getGender().getValue(),
      maritalStatus: this.dependent.getMaritalStatus().getValue(),
      isNewAddress: this.dependent.getAddress().getIsNewAddress(),
      street: this.dependent.getAddress().getStreet(),
      number: this.dependent.getAddress().getNumber(),
      complement: this.dependent.getAddress().getComplement(),
      city: city ? city : 0,
      region: state ? state : 0,
      district: this.dependent.getAddress().getDistrict(),
      zipCode: this.dependent.getAddress().getZipCode(),
      email: this.dependent.getEmail(),
      telephone: this.dependent.getTelephone(),
      mobile: this.dependent.getMobile(),
      needValidateEmail: this.dependent.getNeedValidateEmail(),
      enableDelivery: this.dependent.getEnableDelivery(),
      transactionPasswordRequired: this.dependent.getTransactionPasswordRequired(),
    });
  }

  onBeneficiaryInputChange(): void {
    this.formDirty.markAsDirty();
  }

  public async getZipCode() {
    const formValue = this.dependentForm.get("zipCode").value;
    var boolean = /^\d{5}[-]\d{3}$/.test(formValue);

    if (boolean) {
      const ref = this.loadingService.beginLoading();
      this.dependentForm.get("zipCode").disable();
      try {
        const zip = await this.stateService.getZipCodeIntegration(formValue);
        const state = this.stateList.find((state) => state.getValue() === zip.getStateCode());
        this.dependentForm.get("region").setValue(state);
        await this.onStateInputChange();

        const city = this.cityList.find((city) => city.getName() === zip.getLocality());
        this.dependentForm.get("city").setValue(city);

        this.dependentForm.get("street").setValue(zip.getAddress());
        this.dependentForm.get("district").setValue(zip.getNeighborhood());
      } catch (error) {
        this.toast.showWarningToast("CEP não encontrado.");
      } finally {
        this.loadingService.finishLoading(ref);
        this.dependentForm.get("zipCode").enable();
      }
    }
  }

  async searchBeneficiary() {
    const socialNumber = this.dependentForm.get("socialNumber").value.replace(/[^\d]+/g, "");
    if (socialNumber.length === 11 && this.socialNumberFind !== socialNumber && !this.beneficiaryInfo) {
      this.socialNumberFind = socialNumber;
      this.beneficiaryInfo = await this.searchBeneficiaryBySocialNumber(socialNumber, this.company.getFiscalNumber());
      if (this.beneficiaryInfo) {
        let message = this.beneficiaryInfo.getCompany().length === 1 ? `Beneficiário já está cadastrado no portal junto à empresa ${this.beneficiaryInfo.getCompany()[0].getCorporateName()}.` : `Beneficiário já está cadastrado no portal em ${this.beneficiaryInfo.getCompany().length} empresas.`;
        message += " Para ver mais detalhes clique no ícone de informação (¡) ao lado do campo CPF.";
        this.toast.showWarningToast(message, "CPF já vinculado");
      }
    } else {
      this.beneficiaryInfo = null;
    }
  }

  private async searchBeneficiaryBySocialNumber(socialNumber: string, fiscalNumber:string) {
    const ref = this.loadingService.beginLoading();
    try {
      return await this.beneficiaryService.findBeneficiaryHolderBySocialNumber(socialNumber, fiscalNumber);
    } catch (erro) {
      console.error(erro);
      this.toast.showWarningToast(`Dependente ainda não está cadastrado no portal.`, "CPF não vinculado");
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  openVinculatedDialog() {
    const socialNumber = this.dependentForm.get("socialNumber").value.replace(/[^\d]+/g, "");
    if (socialNumber.length === 11 && this.socialNumberFind === socialNumber) {
      this.dialog.open(VinculatedSocialnumberDialogComponent, {
        id: "status-dialog",
        disableClose: true,
        hasBackdrop: true,
        width: "400px",
        data: { beneficiary: this.beneficiaryInfo },
      });
    }
  }

  async onStateInputChange() {
    const state = this.dependentForm.get("region").value;
    if (state) {
      const ref = this.loadingService.beginLoading();
      try {
        this.cityList = await this.stateService.getCityByStateAcronym(state);
        this.dependentForm.get("city").enable();
        this.dependentForm.get("city").setValue(0);
      } catch (error) {
        this.cityList = [];
        this.dependentForm.get("city").disable();
        this.toast.showWarningToast(error);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.cityList = [];
      this.dependentForm.get("city").setValue(0);
      this.dependentForm.get("city").disable();
    }
  }

  getStateList(): StateAcronym[] {
    return this.stateList;
  }

  getCityList(): City[] {
    return this.cityList;
  }

  public isNewDependent(): boolean {
    return this.dependent && this.dependent.isNew();
  }

  public hasAccessToEditBeneficiary(): boolean {
    return this.userService.getLoggedUser().hasPermission(UserPermissions.EditBeneficiary);
  }

  hasAccessToBeneficiaryBlockCard(): boolean {
    return this.userService.getLoggedUser().hasPermission(UserPermissions.BeneficiaryBlockCard);
  }

  hasAccessToBeneficiaryReactivateCard(): boolean {
    return this.userService.getLoggedUser().hasPermission(UserPermissions.BeneficiaryReactivateCard);
  }

  public goToEditBeneficiary(): void {
    this.beneficiaryService.setDependent(null);
    this.router.navigate([RoutePath.EditBeneficiary, this.beneficiary.getBeneficiaryKey().getValue()]);
  }

  public async createDependent() {
    const ref = this.loadingService.beginLoading();
    const newDependentValidator = new DependentValidator(this.beneficiary);
    if (newDependentValidator.validate(this.dependentForm, new AddDependentBehaviorValidator()).hasErrorMessages()) {
      this.toast.showWarningToast(newDependentValidator.getValidationResult().getErrorMessage());
      this.loadingService.finishLoading(ref);
    } else {
      const dependent: Dependent = this.buildDependent();
      const oldDependents: Dependent[] = [...this.beneficiary.getDependets()];
      const newDependents: Dependent[] = [...this.beneficiary.getDependets()];
      newDependents.push(dependent);
      this.beneficiary.setDependents(newDependents);
      try {
        await this.beneficiaryService.saveBeneficiary(this.fiscalNumber.replace(/[./-]/g, ""), this.beneficiary);
        this.beneficiary = await this.beneficiaryService.findBeneficiaryByKey(this.beneficiary.getBeneficiaryKey());
        this.goToEditBeneficiary();
        this.toast.showSuccessToast("Dependente salvo com sucesso.");
      } catch (error) {
        this.beneficiary.setDependents(oldDependents);
        this.toast.showWarningToast(error);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    }
  }

  public async editDependent() {
    const ref = this.loadingService.beginLoading();
    const newDependentValidator = new DependentValidator(this.beneficiary);
    if (newDependentValidator.validate(this.dependentForm, new EditDependentBehaviorValidator(this.dependent)).hasErrorMessages()) {
      this.toast.showWarningToast(newDependentValidator.getValidationResult().getErrorMessage());
      this.loadingService.finishLoading(ref);
    } else {
      const dependent: Dependent = this.buildDependent();
      const oldDependents: Dependent[] = [...this.beneficiary.getDependets()];
      const newDependents: Dependent[] = [...this.beneficiary.getDependets()].map((item) => {
        if (item.getBeneficiaryKey().getValue() === dependent.getBeneficiaryKey().getValue()) {
          return dependent;
        }
        return item;
      });
      this.beneficiary.setDependents(newDependents);
      try {
        await this.beneficiaryService.saveBeneficiary(this.fiscalNumber.replace(/[./-]/g, ""), this.beneficiary);
        this.beneficiary = await this.beneficiaryService.findBeneficiaryByKey(this.beneficiary.getBeneficiaryKey());
        this.beneficiaryService.setDependent(dependent);
        this.toast.showSuccessToast("Dependente salvo com sucesso");
        this.goToEditBeneficiary();
      } catch (error) {
        this.beneficiary.setDependents(oldDependents);
        this.toast.showWarningToast(error);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    }
  }

  private buildDependent(): Dependent {
    const dependent = new Dependent();

    dependent.setBeneficiaryKey(this.dependentForm.get("beneficiaryKey").value);
    dependent.setBeneficiarySocialNumber(this.dependentForm.get("beneficiarySocialNumber").value.replace(/[^\d]+/g, ""));

    dependent.setName(this.dependentForm.get("name").value);
    dependent.setSocialNumber(this.dependentForm.get("socialNumber").value.replace(/[^\d]+/g, ""));
    dependent.setBirthDate(this.dependentForm.get("birthDate").value.replace(/[^\d]+/g, ""));
    dependent.setNeedValidateEmail(this.dependentForm.get("needValidateEmail").value);
    dependent.setEnableDelivery(this.dependentForm.get("enableDelivery").value);
    dependent.setTransactionPasswordRequired(this.dependentForm.get("transactionPasswordRequired").value);

    const card = new Card();
    card.setCardNumber(this.dependentForm.get("cardNumber").value);
    dependent.setCard(card);

    const personGender = new Gender();
    personGender.setGender(this.dependentForm.get("gender").value);
    dependent.setGender(personGender);

    const personMaritalStatus = new MaritalStatus();
    personMaritalStatus.setMaritalStatus(this.dependentForm.get("maritalStatus").value);
    dependent.setMaritalStatus(personMaritalStatus);

    const address = new Address();
    address.setIsNewAddress(this.dependentForm.get("isNewAddress").value);
    address.setStreet(this.dependentForm.get("street").value);
    address.setNumber(this.dependentForm.get("number").value);
    address.setComplement(this.dependentForm.get("complement").value);
    address.setZipCode(this.dependentForm.get("zipCode").value);
    address.setDistrict(this.dependentForm.get("district").value);

    if (this.dependentForm.get("isNewAddress").value == true) {
      address.setCity(this.dependentForm.get("city").value.getName());
      address.setRegion(this.dependentForm.get("region").value.getValue());
    }

    dependent.setAddress(address);
    dependent.setEmail(this.dependentForm.get("email").value);
    dependent.setTelephone(this.dependentForm.get("telephone").value.replace(/[^\d]+/g, ""));
    dependent.setMobile(this.dependentForm.get("mobile").value.replace(/[^\d]+/g, ""));

    return dependent;
  }

  openCardBlockDialog(): void {
    this.cardBlockDialogRef = this.dialog.open(CardBlockDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: "345px",
      width: "600px",
      data: this.dependent,
    });

    this.cardBlockDialogRef.componentInstance.blockCardNumberEvent.subscribe(async (data) => {
      this.goToEditBeneficiary();
    });
  }

  openCardUnblockDialog(): void {
    this.cardUnblockDialogRef = this.dialog.open(CardUnblockDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: "300px",
      width: "600px",
      data: this.dependent,
    });

    this.cardUnblockDialogRef.componentInstance.unblockCardNumberEvent.subscribe(async (data) => {
      this.goToEditBeneficiary();
    });
  }

  async exportBeneficiaryUsageFile(): Promise<any> {
    const loadingRef = this.loadingService.beginLoading();
    try {
      const data = await this.beneficiaryService.exportBeneficiaryUsageFileByCardNumber(this.dependent.getCard().getCardNumber());
      const a = document.createElement("a");
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(data);
      a.href = url;
      a.download = `Relatório_Consumo_${this.dependent.getSocialNumber()}.csv`;
      a.click();
      this.toast.showSuccessToast("Arquivo .csv exportado com sucesso.");
    } catch (error) {
      console.log(error);
    } finally {
      loadingRef.closeLoading();
    }
  }

  isDependentCardBlocked(): boolean {
    return this.dependent && this.dependent.getCard() && this.dependent.getCard().getIsBlocked();
  }

  isDependentCardCancelled(): boolean {
    return this.dependent.getCard() && this.dependent.getCard()?.getIsCancelled();
  }

  isDependentActive(): boolean {
    return this.dependent && this.dependent.isActive();
  }

  public isEditableDependent(): boolean {
    return this.hasAccessToEditBeneficiary() && !this.isDependentCardCancelled();
  }

  onCancelDependentCard(): void {
    this.confirmDialogRef = this.dialog.open(ConfirmDialog, {
      disableClose: true,
      hasBackdrop: true,
      height: "200px",
      width: "600px",
      data: {
        title: "Cancelamento de Cartão",
        text: "Deseja cancelar o cartão do beneficiário?",
      },
    });

    this.confirmDialogRef.componentInstance.confirmDialogEvent.subscribe(async () => {
      const loadingRef = this.loadingService.beginLoading();

      try {
        await this.beneficiaryService.cancelBeneficiaryCard(this.dependent.getBeneficiaryKey());
        this.beneficiary = await this.beneficiaryService.findBeneficiaryByKey(this.beneficiary.getBeneficiaryKey());
        this.goToEditBeneficiary();
        this.toast.showSuccessToast("Cartão cancelado com sucesso");
      } catch (error) {
        this.toast.showWarningToast("Erro ao cancelar o cartão");
      } finally {
        loadingRef.closeLoading();
      }
    });
  }

  async onOrderDependentCard() {
    const loadingRef = this.loadingService.beginLoading();

    try {
      const orderCardDTO = await this.beneficiaryService.orderBeneficiaryCard(this.dependent.getBeneficiaryKey());
      this.dependent.setCard(orderCardDTO.getCard());
      this.patchRegistrationDependentForm();
      this.goToEditBeneficiary();
      this.openOrderBeneficiaryCardDialog(orderCardDTO);
    } catch (error) {
      this.toast.showWarningToast(error.error.Data.ErrorMessage);
    } finally {
      loadingRef.closeLoading();
    }
  }

  private openOrderBeneficiaryCardDialog(orderCardDTO: OrderCardDTO) {
    this.cardOrderDialogRef = this.dialog.open(CardOrderDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: "320px",
      width: "600px",
      data: orderCardDTO,
    });
  }
}
